import { Nullable } from '@dxb-web-ui-framework/common/types';
import {
  APIGatewayResponse,
  APIGatewayResponseDataHeader,
} from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';

export type ValueDateResponseBody = {
  dateTime: string;
};

export enum Priorities {
  NORMAL = 'NORMAL',
  IMMEDIATE = 'IMMEDIATE',
}

class ValueDateResponseDTO implements APIGatewayResponse<ValueDateResponseBody> {
  headers: APIGatewayResponseDataHeader[];
  body: Nullable<ValueDateResponseBody>;

  constructor(headers: APIGatewayResponseDataHeader[], body: Nullable<ValueDateResponseBody>) {
    this.headers = headers;
    this.body = body;
  }
}

export { ValueDateResponseDTO };
